import { Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth/types';
import { ValidationLayout } from 'src/features/validations/components/ValidationLayout';
import ValidationTable from 'src/features/validations/routes/ValidationTable';
import useHasPermissions from 'src/hooks/useHasPermissions';

export default function ValidationRoutes() {
    const accessValidations = useHasPermissions([PERMISSION.ALLOW_VALIDATIONS]);

    return (
        <Routes>
            {accessValidations && (
                <Route path="" element={<ValidationLayout />}>
                    <Route path="" element={<ValidationTable />} />
                </Route>
            )}
        </Routes>
    );
}
